// Add your JS customizations here
jQuery(document).ready(function($) { 
	$('body').addClass('active');

	new WOW().init();

	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');
		$('#main_nav').toggleClass('menu_open');
		$('#cwk_menu').toggleClass('active');
		$('body').toggleClass('menu_open');
		$('.navbar').removeClass('menu_scroll');
		$('#cwk_menu').scrollTop(0);
	});

	var cwk_menu = $('#cwk_menu');

	$(cwk_menu).on('scroll', function() {
		if ($(cwk_menu).scrollTop() > 50) {
			$('.navbar').addClass('menu_scroll');
		} else {
			$('.navbar').removeClass('menu_scroll');
		}
	});

	var navHeight = $('#main_nav').outerHeight(true);

	$('#fw_wrapper').css('margin-top',navHeight);
	$( window ).resize(function() {
		if ($(window).width() > 991.98) {
			var navHeightResize = $('#main_nav').outerHeight(true);
			$('#fw_wrapper').css('margin-top',navHeightResize);
		}
	});

	if ($('.page-template-home').length > 0) {
		if ($(window).width() < 991.98) {
			if ($('.video_container_mobile').length > 0) {
				$('#header .video_container_mobile iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else {
				$('#header .video_container_desktop iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			}
			if ($('.video_container').length > 0) {
				$('#header .video_container').css('height','calc(100vh - ' + navHeight + 'px - 1.25rem)');
				$('#header .video_container iframe').css('height','calc(100vh - ' + navHeight + 'px - 1.25rem)');
				$('#header .video_overlay').css('height','calc(100vh - ' + navHeight + 'px - 1.25rem)');
			}
		}
		if ($(window).width() > 991.98) {
			if ($('.video_container_desktop').length > 0) {
				$('#header .video_container_desktop iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
				$('#header .video_container').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
				$('#header .video_container iframe').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
				$('#header .video_overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			};
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
		};

		$( window ).resize(function() {
			var navHeightResize = $('#main_nav').outerHeight(true);
			if ($(window).width() > 991.98) {
				if ($('.video_container_desktop').length > 0) {
					$('#header .video_container').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
					$('#header .video_container iframe').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
					$('#header .video_overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				}
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			};
		});

		$('#sectors_selection_expand').click(function() {
			$('#sectors_selection .gradient').toggleClass('show_gradient');
			$(this).html($(this).html() == '<i class="fal fa-arrow-down mrx_10"></i>Load more' ? '<i class="fal fa-arrow-up mrx_10"></i>Show less' : '<i class="fal fa-arrow-down mrx_10"></i>Load more');
		});
	}

	if ($('.page-template-join').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var headerHeight = $('#inner_content').outerHeight(true);

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				var headerHeight_translate = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');

			});

			$( window ).resize(function() {
				var headerHeightResize = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	if ($('.page-template-thanks').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var headerHeight = $('#inner_content').outerHeight(true);

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$( window ).resize(function() {
				var headerHeightResize = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var headerHeight_translate = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	if ($('.error404').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var headerHeight = $('#inner_content').outerHeight(true);

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var headerHeight_translate = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

			$( window ).resize(function() {
				var headerHeightResize = $('#inner_content').outerHeight(true);

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	

	if ($('.page-template-who').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var col_1_height = $('.col_1').outerHeight(true);
			var col_2_height = $('.col_2').outerHeight(true);
			var headerHeight = col_1_height + col_2_height;

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var col_1_height_translate = $('.col_1').outerHeight(true);
				var col_2_height_translate = $('.col_2').outerHeight(true);
				var headerHeight_translate = col_1_height_translate + col_2_height_translate;

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

			$( window ).resize(function() {
				var col_1_heightResize = $('.col_1').outerHeight(true);
				var col_2_heightResize = $('.col_2').outerHeight(true);
				var headerHeightResize = col_1_heightResize + col_2_heightResize;

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	if ($('.page-template-what').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var col_1_height = $('.col_1').outerHeight(true);
			var col_2_height = $('.col_2').outerHeight(true);
			var headerHeight = col_1_height + col_2_height;

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var col_1_height_translate = $('.col_1').outerHeight(true);
				var col_2_height_translate = $('.col_2').outerHeight(true);
				var headerHeight_translate = col_1_height_translate + col_2_height_translate;

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

			$( window ).resize(function() {
				var col_1_heightResize = $('.col_1').outerHeight(true);
				var col_2_heightResize = $('.col_2').outerHeight(true);
				var headerHeightResize = col_1_heightResize + col_2_heightResize;

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
		
	}

	if ($('.page-template-submit').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var col_1_height = $('.col_1').outerHeight(true);
			var col_2_height = $('.col_2').outerHeight(true);
			var headerHeight = col_1_height + col_2_height;

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var col_1_height_translate = $('.col_1').outerHeight(true);
				var col_2_height_translate = $('.col_2').outerHeight(true);
				var headerHeight_translate = col_1_height_translate + col_2_height_translate;

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

			$( window ).resize(function() {
				var col_1_heightResize = $('.col_1').outerHeight(true);
				var col_2_heightResize = $('.col_2').outerHeight(true);
				var headerHeightResize = col_1_heightResize + col_2_heightResize;

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	if ($('.page-template-contact').length > 0) {
		$('.fit_cover').addClass('active');
		if ($(window).width() < 991.98) {
			var col_1_height = $('.col_1').outerHeight(true);
			var col_2_height = $('.col_2').outerHeight(true);
			var headerHeight = col_1_height + col_2_height;

			$('#header').css('height','calc(5rem + ' + headerHeight +'px)');
			$('#header_bg').css('height','calc(5rem + ' + headerHeight +'px)');

			$('html').bind('DOMSubtreeModified', function(e) {
				console.log('translated');
				var col_1_height_translate = $('.col_1').outerHeight(true);
				var col_2_height_translate = $('.col_2').outerHeight(true);
				var headerHeight_translate = col_1_height_translate + col_2_height_translate;

				$('#header').css('height','calc(5rem + ' + headerHeight_translate +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeight_translate +'px)');
			});

			$( window ).resize(function() {
				var col_1_heightResize = $('.col_1').outerHeight(true);
				var col_2_heightResize = $('.col_2').outerHeight(true);
				var headerHeightResize = col_1_heightResize + col_2_heightResize;

				$('#header').css('height','calc(5rem + ' + headerHeightResize +'px)');
				$('#header_bg').css('height','calc(5rem + ' + headerHeightResize +'px)');
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px)');
			$('#header .card').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
				$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		}
	}

	if ($('.page-template-sector').length > 0) {

		$('.fit_cover').addClass('active');
		
		if ($(window).width() < 991.98) {
			$('#reviews_carousel_xs').on('init', function(event, slick){
				var reviewsHeight = $('#reviews_carousel_xs').outerHeight(true);
				console.log(reviewsHeight);
				$('.reviews_xs').height(reviewsHeight);
			});
			
			var headerHeight = $('#header').outerHeight(true);
			
			var col_1_height = $('.col_1').outerHeight(true);
			var col_2_height = $('.col_2').outerHeight(true);
			var total_height = col_1_height + col_2_height;
			$('#header_bg').css('height',total_height);

			$('html').bind('DOMSubtreeModified', function(e) {
				var col_1_height_translate = $('.col_1').outerHeight(true);
				var col_2_height_translate = $('.col_2').outerHeight(true);
				var total_height_translate = col_1_height_translate + col_2_height_translate;
				$('#header_bg').css('height',total_height_translate);
			});

			var headerScroll = navHeight + headerHeight;
			console.log(headerScroll);
			$(window).scroll(function() {
				if ($(this).scrollTop() > headerHeight) {
					$('.open_reviews_xs').addClass('fade_out');
				} else {
					$('.open_reviews_xs').removeClass('fade_out');
				}
			});
		}
		if ($(window).width() > 992) {
			$('#header').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header_bg').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');
			$('#header_bg .card-img-overlay').css('height','calc(100vh - ' + navHeight + 'px - 3.125vw)');

			$( window ).resize(function() {
				var navHeightResize = $('#main_nav').outerHeight(true);
				$('#header').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header_bg').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
				$('#header_bg .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
			});
		};

		// $( window ).resize(function() {
		// 	if ($(window).width() > 991.98) {
		// 		$('#header').css('height','calc(100vh - ' + navHeightResize + 'px)');
		// 		$('#header .card').css('height','calc(100vh - ' + navHeightResize + 'px)');
		// 		$('#header .card-img-overlay').css('height','calc(100vh - ' + navHeightResize + 'px - 3.125vw)');
		// 	};
		// });
		$('.open_reviews').click(function(event) {
			event.preventDefault();
			$('.reviews').toggleClass('active');
			$(this).toggleClass('inactive');
			$('.close_reviews').toggleClass('active');
		});
		$('.open_reviews_xs').click(function(event) {
			event.preventDefault();
			$('.reviews_xs').toggleClass('active');
			$(this).toggleClass('inactive');
			$(window).scrollTop(0);
		});
		$('.close_reviews').click(function(event) {
			event.preventDefault();
			$('.reviews').toggleClass('active');
			$('.open_reviews').toggleClass('inactive');
			$('.close_reviews').toggleClass('active');
		});
		$('.close_reviews_xs').click(function(event) {
			event.preventDefault();
			$('.reviews_xs').toggleClass('active');
			$('.open_reviews_xs').toggleClass('inactive');
		});

		$('#reviews_carousel').slick({
			autoplay: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $('.review_prev'),
			nextArrow: $('.review_next'),
			dots: false,
		});

		$('#reviews_carousel_xs').slick({
			autoplay: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $('.review_xs_prev'),
			nextArrow: $('.review_xs_next'),
			dots: false,
		});
	}
});
